import React from "react";
import { Checkbox, Trophy } from "../../assets/svg/icons";

const InstructionListMobile = () => {
  return (
    <>
      <h2 className="instruction_title">Vem bestämmer vad?</h2>
      <ul className="instructions_list">
        <li className="instructions_list_item">
          <div className="instruction">
            <span>1</span>
            <p>
              Svara på frågorna genom att välja en av de 3 alternativ som visas.
            </p>
          </div>
          <Checkbox />
        </li>
        <li className="instructions_list_item">
          <div className="instruction">
            <span>2</span>
            <p>Se ditt resultat och utmana dig själv genom att spela igen.</p>
          </div>
          <Trophy />
        </li>
      </ul>
    </>
  );
};

export default InstructionListMobile;
